export const nftData = [
    {
        title: "Parazzy NFT",
        image_url: "https://gametable.org/res/images/og/tabletop-tic-tac-toe-og-1200x1200.png",
        desc: "Play-to-Earn mobile strategy game on SOLID protocol",
        subTitle: "Ecosystem and it's environs",
        price: "20EVMOS"
        
    },
    {
        title: "Abbie Kyle",
        image_url: "https://gametable.org/res/images/og/tabletop-tic-tac-toe-og-1200x1200.png",
        desc: "Play-to-Earn mobile strategy game on SOLID protocol",
        subTitle: "Ecosystem and it's environs",
        price: "10EVMOS"
    },
    {
        title: "Parazzy",
        image_url: "https://gametable.org/res/images/og/tabletop-tic-tac-toe-og-1200x1200.png",
        desc: "Play-to-Earn mobile strategy game on SOLID protocol",
        subTitle: "Ecosystem and it's environs",
        price: "50EVMOS"
    },
    {
        title: "Parazzy",
        image_url: "https://gametable.org/res/images/og/tabletop-tic-tac-toe-og-1200x1200.png",
        desc: "Play-to-Earn mobile strategy game on SOLID protocol",
        subTitle: "Ecosystem and it's environs",
        price: "30EVMOS"
    },
    {
        title: "Parazzy",
        image_url: "https://gametable.org/res/images/og/tabletop-tic-tac-toe-og-1200x1200.png",
        desc: "Play-to-Earn mobile strategy game on SOLID protocol",
        subTitle: "Ecosystem and it's environs",
        price: "10EVMOS"
    },
    {
        title: "Parazzy",
        image_url: "https://gametable.org/res/images/og/tabletop-tic-tac-toe-og-1200x1200.png",
        desc: "Play-to-Earn mobile strategy game on SOLID protocol",
        subTitle: "Ecosystem and it's environs",
        price: "10EVMOS"
    },
    {
        title: "Parazzy",
        image_url: "https://gametable.org/res/images/og/tabletop-tic-tac-toe-og-1200x1200.png",
        desc: "Play-to-Earn mobile strategy game on SOLID protocol",
        subTitle: "Ecosystem and it's environs",
        price: "10EVMOS"
    },
]